import { infiniteQueryOptions } from '@tanstack/react-query';

import { apiAdminViewsFetch } from '..';
import {
  ADMIN_VIEWS_ENTITIES_QUERY_KEY,
  ADMIN_VIEWS_FUNDS_QUERY_KEY,
  ADMIN_VIEWS_QUERY_KEY,
} from './queries';
import type {
  AdminViewsEntitiesParams,
  AdminViewsEntitiesRes,
  AdminViewsFundsParams,
  AdminViewsFundsRes,
  AdminViewsUsersParams,
  AdminViewsUsersRes,
} from './types';

export const _getAdminViewsUsersInfinite = (params: Omit<AdminViewsUsersParams, 'page'> = {}) =>
  infiniteQueryOptions({
    refetchOnMount: true,
    queryKey: [...ADMIN_VIEWS_QUERY_KEY.usersRoot, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiAdminViewsFetch<AdminViewsUsersRes>('/users', {
        params: { ...params, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
  });

export const _getAdminViewsEntitiesInfinite = (
  params: Omit<AdminViewsEntitiesParams, 'page'> = {},
) =>
  infiniteQueryOptions({
    refetchOnMount: true,
    queryKey: [...ADMIN_VIEWS_ENTITIES_QUERY_KEY.entitiesRoot, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiAdminViewsFetch<AdminViewsEntitiesRes>('/entities', {
        params: { ...params, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
  });

export const _getAdminViewsFundsInfinite = (params: Omit<AdminViewsFundsParams, 'page'> = {}) =>
  infiniteQueryOptions({
    refetchOnMount: true,
    queryKey: [...ADMIN_VIEWS_FUNDS_QUERY_KEY.fundsRoot, 'infinite', params],
    queryFn: ({ pageParam = 1 }) =>
      apiAdminViewsFetch<AdminViewsFundsRes>('/funds', {
        params: { ...params, page: pageParam, limit: 20 },
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.pagination.page < lastPage.pagination.totalPages
        ? lastPage.pagination.page + 1
        : undefined,
  });
